<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
  
    <vue-snotify></vue-snotify>

    <modal-container />

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import EventBus from './bus'
  import {SnotifyStyle} from 'vue-snotify';
  export default {
    mounted() {
      EventBus.$on('error', payload => {
        this.$snotify.error(payload, 'Error', {
          timeout: 7500
        })
      })
      EventBus.$on('docUploadError', payload => {
        this.$snotify.html(
          `
          <div class="snotifyToast__title"><b>Document upload timed out.</b></div>
          <div class="snotifyToast__body">
            <div>Your document(s) upload timed out after 5 minutes. This may have been caused by;</div>
            <ul>
              <li>Documents attached are too large.</li>
              <li>Too many documents attached.</li>
              <li>Slow internet connection when uploading documents.</li>
            </ul>
            <div>Please reduce the size your document upload and try again;</div>
            <ul>
              <li>Reduce each document to less than 5MB in size, ideally less (free online tools are available).</li>
              <li>Only submit required documents.</li>
              <li>Submit multiple verifications separately if possible.</li>
              <li>Use a faster internet connection, avoid mobile data uploads.</li>
            </ul>
            <div>(click to dismiss)</div>
          </div>
          `
        , {
          timeout: 0,
          type: SnotifyStyle.warning
        })
      })
    }
  }
</script>